import React, { Fragment, useState, useCallback } from 'react';
import ApprovalTypeContainer from './ApprovalTypeContainer';
import ApprovalTypeHeader from './header/ApprovalTypeHeader';
import ApprovalTypeHeaderLinks from './header/ApprovalTypeHeaderLinks';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { getInt } from 'utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from '../../../../components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_APPROVAL_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const match = useRouteMatch();
  const approvalTypeId = match.params.approvalTypeId && getInt(match.params.approvalTypeId);
  const siteId = match.params.siteId && getInt(match.params.siteId);

  const [disabledSave, setDisabledSave] = useState(true);
  const [onSave, setOnSave] = useState({ fn: () => {} });

  const { push } = useHistoryWithContext();
  const onEdit = useCallback(
    approvalTypeLevelId => {
      push(`/approvalTypes/${approvalTypeId}/${siteId}/approvalTypeLevel/${approvalTypeLevelId}/${siteId}`);
    },
    [approvalTypeId, push, siteId]
  );

  const onAdd = useCallback(() => {
    push(`/approvalTypes/${approvalTypeId}/${siteId}/new`);
  }, [approvalTypeId, push, siteId]);

  const onClose = useCallback(() => {
    push(`/approvalTypes`);
  }, [push]);

  const onRedirect = useCallback(
    (approvalTypeId, siteId) => {
      push(`/approvalTypes/${approvalTypeId}/${siteId}`);
    },
    [push]
  );

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <ApprovalTypeHeader />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <ApprovalTypeHeaderLinks onClose={onClose} onSave={onSave.fn} disabledSave={disabledSave} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_APPROVAL_TYPES}>
        <ApprovalTypeContainer
          approvalTypeId={approvalTypeId}
          siteId={siteId}
          onEdit={onEdit}
          onAdd={onAdd}
          onSaveFnChanged={onSaveFnChanged}
          onRedirect={onRedirect}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
